import { KTCard } from '../../../../../_metronic/helpers'
import { QueryRequestProvider, useQueryRequest } from './core/QueryRequestProvider'
import { SubscriptionPlansTable } from './table/SubscriptionPlansTable'
import { ListViewProvider } from './core/ListViewProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { ListHeader } from './table/ListHeader'

const SubscriptionPlansList = () => {
  const { updateState } = useQueryRequest()
  return (
    <>
      <KTCard>
        <ListHeader updateState={updateState} />
        <SubscriptionPlansTable />
      </KTCard>
    </>
  )
}

const SubscriptionPlansListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <SubscriptionPlansList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { SubscriptionPlansListWrapper }
